<template>
    <div class="image-container set-full-height">
        <div class="container">
            <div class="row">
                <div class="col-sm-8 col-sm-offset-2" style="background-color:#e2e1de">

                    <h3 align="center" style="color:#000; font-family:Prompt">ระบบทำบัตรออนไลน์ คณะแพทยศาสตร์
                        ม.สงขลานครินทร์&nbsp;&nbsp;<a href="index.html" style="color:#000"><i class="ti-home"></i></a>
                    </h3>
                    <!--      Wizard container        -->
                    <div class="wizard-container">

                        <div class="card wizard-card" data-color="orange" id="wizardProfile">
                            <form action="" method="">
                                <!--        You can switch " data-color="orange" "  with one of the next bright colors: "blue", "green", "orange", "red", "azure"          -->

                                <div class="wizard-header text-center">
                                    <div align="right" style="">ไชยยันต์ ปาละมาณ ฝ่ายเทคโนโลยีสารสนเทศ</div>
                                    <div class="tab-content" style="margin-top:-20px;">
                                        <div class="row">
                                            <div class="col-sm-12 col-sm-offset-0">
                                                <h4 style="color:#000; font-family:Prompt"><u>ข้อมูลการขอทำบัตร</u></h4>
                                                <table class="table" style="color:#fff; font-family:Prompt">
                                                    <tr style="color:#fff; font-family:Prompt; font-size:18px;; background-color:#8cc63e"
                                                        align="left">
                                                        <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                                            align="left">#
                                                        </td>
                                                        <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                                            align="left">รายการขอทำบัตร
                                                        </td>
                                                        <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                                            align="left">วันที่ยืนขอทำบัตร
                                                        </td>
                                                        <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                                            align="left">สถานะดำเนินการ
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td style="color:#000; font-family:Prompt; font-size:18px;"
                                                            align="left">1.
                                                        </td>
                                                        <td style="color:#000; font-family:Prompt; font-size:18px;"
                                                            align="left">ขอทำบัตรบุคลากร
                                                        </td>
                                                        <td style="color:#000; font-family:Prompt; font-size:18px;"
                                                            align="left">29 พฤศจิกายน 2562
                                                        </td>
                                                        <td style="color:#000; font-family:Prompt; font-size:18px;"
                                                            align="left">พิจารณาคำขอ
                                                        </td>
                                                    </tr>

                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div> <!-- wizard container -->
                    <h5 align="center" style="color:#000; font-family:prompt;">งานการเจ้าหน้าที่
                        อาคารบริหารคณะแพทยศาสตร์ ชั้น 4 คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์ <br>ติดต่อ 074-45-1140
                        หรือ 074-45-1144 Email : person@medcine.psu.ac.th</h5>
                </div>

            </div><!-- end row -->
        </div>
    </div>
</template>

<script>

    import axios from 'axios'

    export default {
        name: "ManageCard",
        data: function () {
            return {
                perid: '',
                idcard: '',
                nameTh: '',
                nameEn: '',
                hn: '',
                brithDay: '',
                gender: '',
                depart: '',
                phoneDepart: '',
                phoneMoblie: '',
                phoneHome: '',
                email: '',
                address: '',
                dorm: '',
                dorm2: '',
                car: '',
                car2: '',
                bike: '',
                bike2: '',
                options: {
                    url: '/upload',
                    paramName: 'file'
                },
                position: '',
                FilePersonal: '',
                FileRecript: '',
                FileHome: '',
                selectFile: '',
                pic_Profile: require('@/assets/img/NonPic.png'),
                // pic_Profile: require('@/assets/img/ShowfPict.jpg'),
                dataFormSubmit: {
                    request: {
                        request_types_id: "3",
                        request_wish_id: "1",
                        quantity: "1"
                    },
                    items: [
                        {
                            person: {
                                person_types_id: "2",
                                perid: "",
                                citizenId: "",
                                firstName: "",
                                lastName: "",
                                birthdate: "",
                                sex: ""
                            },
                            contact: [
                                {
                                    contact_types_id: "1",
                                    value: ""
                                },
                                {
                                    contact_types_id: "2",
                                    value: ""
                                },
                                {
                                    contact_types_id: "3",
                                    value: ""
                                },
                                {
                                    contact_types_id: "4",
                                    value: ""
                                },
                                {
                                    contact_types_id: "5",
                                    value: ""
                                },
                                {
                                    contact_types_id: "6",
                                    value: ""
                                }
                            ],
                            dorm: [
                                {
                                    dorm_types_id: "1",
                                    value: "-"
                                },
                                {
                                    dorm_types_id: "2",
                                    value: "-"
                                }
                            ],
                            vehicle: [],
                            attachment: [
                                {
                                    attachment_types_id: "1",
                                    url: ""
                                },
                                {
                                    attachment_types_id: "2",
                                    url: ""
                                },
                                {
                                    attachment_types_id: "3",
                                    url: ""
                                },
                                {
                                    attachment_types_id: "4",
                                    url: ""
                                },
                                {
                                    attachment_types_id: "5",
                                    url: ""
                                }
                            ]
                        }
                    ]
                }
            };
        },
        methods: {
            SubmitForm: function () {
                var that = this;
                setTimeout(function () {
                    that.$swal('บันทึกข้อมูลสำเร็จ');
                    that.$router.push('/')
                }, 1000)
            },
            FileSelectPersonal: function (event) {
                if (event.target.files[0]) {
                    const fd = new FormData()
                    fd.append('file', event.target.files[0], event.target.files[0].name)
                    const headerAxios = {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'WithCredentials': true,
                            "Access-Control-Allow-Origin": "*"
                            // "Accept": 'multipart/form-data'
                        }
                    }

                    axios.post('http://localhost:8081rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                        if (res.data.status) {
                            this.FilePersonal = res.data.path
                        } else {
                            this.FilePersonal = ''
                        }
                    })
                } else {
                    this.FilePersonal = ''
                }

            },
            FileSelectRecript: function (event) {
                if (event.target.files[0]) {
                    const fd = new FormData()
                    fd.append('file', event.target.files[0], event.target.files[0].name)
                    const headerAxios = {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'WithCredentials': true,
                            "Access-Control-Allow-Origin": "*"
                            // "Accept": 'multipart/form-data'
                        }
                    }

                    axios.post('http://localhost:8081rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                        if (res.data.status) {
                            this.FileRecript = res.data.path
                        } else {
                            this.FileRecript = ''
                        }
                    })
                } else {
                    this.FilePersonal = ''
                }
            },
            FileSelectHome: function (event) {
                if (event.target.files[0]) {
                    const fd = new FormData()
                    fd.append('file', event.target.files[0], event.target.files[0].name)
                    const headerAxios = {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'WithCredentials': true,
                            "Access-Control-Allow-Origin": "*"
                            // "Accept": 'multipart/form-data'
                        }
                    }

                    axios.post('http://localhost:8081rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                        if (res.data.status) {
                            this.FileHome = res.data.path
                        } else {
                            this.FileHome = ''
                        }
                    })
                } else {
                    this.FilePersonal = ''
                }
            },
            onFileSelected: function (event) {
                if (event.target.files[0]) {

                    if (event.target.files[0]) {
                        this.url = URL.createObjectURL(event.target.files[0])
                        this.pic_Profile = this.url
                        // this.pic_Profile = require('@/assets/img/ShowfPict.jpg')
                    } else {
                        this.pic_Profile = require('@/assets/img/NonPic.png')
                    }

                    // this.selectFile = this.onUpload(this.selectFile);

                    const fd = new FormData()
                    fd.append('file', event.target.files[0], event.target.files[0].name)
                    const headerAxios = {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'WithCredentials': true,
                            "Access-Control-Allow-Origin": "*"
                            // "Accept": 'multipart/form-data'
                        }
                    }

                    axios.post('http://localhost:8081rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                        if (res.data.status) {
                            this.selectFile = res.data.path
                        } else {
                            this.selectFile = ''
                        }
                    })
                } else {
                    this.FilePersonal = ''
                    this.pic_Profile = require('@/assets/img/NonPic.png')
                }
            },
            onUpload: function (dataFile) {
                const fd = new FormData()
                fd.append('file', dataFile, dataFile.name)
                const headerAxios = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'WithCredentials': true,
                        "Access-Control-Allow-Origin": "*"
                        // "Accept": 'multipart/form-data'
                    }
                }

                axios.post('http://localhost:8081rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                    if (res.data.status) {
                        return res.data.path
                    } else {
                        return null
                    }
                })
            },
            OnInit: function () {
                const headerAxios = {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }

                axios.get('http://localhost:8081/app-api/v2/?/apis/cardnew/request_view', headerAxios).then(res => {
                    if (res.data) {
                      window.console.log(res.data)
                    } else {
                        window.console.log(res.data)
                    }
                })
            }
        },
        mounted() {

            if (this.$cookies.get('access_token')) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$cookies.get('access_token');
                this.OnInit()
            } else {
                // this.$cookies.set('access_token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwZXJpZCI6IjQ2NzkyIiwibmFtZSI6Ilx1MGUxOFx1MGUyN1x1MGUzMVx1MGUwYVx1MGUwYVx1MGUzMVx1MGUyMiIsInN1cm5hbWUiOiJcdTBlMDhcdTBlMzFcdTBlMTlcdTBlMTdcdTBlMjNcdTBlMTdcdTBlMzRcdTBlMWVcdTBlMjJcdTBlNGMifQ.YTW8R5wDrEPUPv5HkvfewbiQKBwpF18o5ZBxwZPtk1o')

                this.$session.set('vurl','http://localhost:8081CardRegister/#/Card2')
                window.location.href = 'http://localhost:8081SingleSign/';
            }

            setTimeout(function () {
                let Jquery = document.createElement('script')
                Jquery.setAttribute('src', 'https://code.jquery.com/jquery-2.2.4.js')
                document.head.appendChild(Jquery)
                let recaptchaScript2 = document.createElement('script')
                recaptchaScript2.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/bootstrap.min.js')
                document.head.appendChild(recaptchaScript2)
                let recaptchaScript3 = document.createElement('script')
                recaptchaScript3.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/jquery.bootstrap.wizard.js')
                document.head.appendChild(recaptchaScript3)
                let recaptchaScript4 = document.createElement('script')
                recaptchaScript4.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/demo.js')
                document.head.appendChild(recaptchaScript4)
                let recaptchaScript5 = document.createElement('script')
                recaptchaScript5.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/paper-bootstrap-wizard.js')
                document.head.appendChild(recaptchaScript5)
                let recaptchaScript6 = document.createElement('script')
                recaptchaScript6.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/jquery.validate.min.js')
                document.head.appendChild(recaptchaScript6)
            }, 100)
            setTimeout(function () {
                let recaptchaScript = document.createElement('script')
                recaptchaScript.setAttribute('src', 'https://code.jquery.com/jquery-2.2.4.js')
                document.head.appendChild(recaptchaScript)
                let recaptchaScript2 = document.createElement('script')
                recaptchaScript2.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/bootstrap.min.js')
                document.head.appendChild(recaptchaScript2)
                let recaptchaScript3 = document.createElement('script')
                recaptchaScript3.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/jquery.bootstrap.wizard.js')
                document.head.appendChild(recaptchaScript3)
                let recaptchaScript4 = document.createElement('script')
                recaptchaScript4.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/demo.js')
                document.head.appendChild(recaptchaScript4)
                let recaptchaScript5 = document.createElement('script')
                recaptchaScript5.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/paper-bootstrap-wizard.js')
                document.head.appendChild(recaptchaScript5)
                let recaptchaScript6 = document.createElement('script')
                recaptchaScript6.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/jquery.validate.min.js')
                document.head.appendChild(recaptchaScript6)
            }, 300)
        }
    }
</script>

<style scoped>

</style>
